import Empty from '../../components/empty/Empty'

import './pages.css'

const Love = ({isCurrent, data}) => {

      if(isCurrent !== 'love') return 

      if(data.data){
            return (
                  <div className={isCurrent === 'love' ? "content_page show" : "content_page"}>
                        <Empty text={`Not Found Relationship`}/>
                  </div>
            )
      }

      const AVATAR = `https://api.dicebear.com/5.x/initials/svg?seed=${data.name}&font-size=26`

      return (
            <div className={isCurrent === 'love' ? "content_page show" : "content_page"}>
                  <div className="content_page__inner">
                        <div className="relation_avatar">
                              <img src={data.avatar === '' ? AVATAR : data.avatar} alt={data.name} />
                        </div>
                        <h2 data-id={data.id_xat}>{data.name}</h2>
                        <div className="relation_description">
                              <p>{data.about}</p>
                        </div>
                        <a href={data.me} target="_blank" rel="noreferrer">xat.me</a>
                  </div>
            </div>
      )

}

export default Love
